import { ColaSourcesTable } from './ColaSourcesTable'

export default ColaSourcesTable
